import { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import EventsContext from '../store/client/EventsContext';
import { Spinner, useToast } from '@chakra-ui/react';
import { HttpContext } from '../context/HttpContext';
import { getErrorResponsePayload } from '../utils/ajax';
import { useReportAndToastApiError } from './useReportAndToastApiError';

const UseEvent = ({ children, admin }) => {
  const { uuid } = useParams();
  const { authAxios } = useContext(HttpContext);
  const eventsCtx = useContext(EventsContext);
  const navigate = useNavigate();
  // const eventsCtxAdmin = useContext(EventsContextAdmin);
  const toast = useToast();
  const reportAndToastApiError = useReportAndToastApiError();

  // const loading = admin
  //   ? eventsCtxAdmin?.eventState?.name === ''
  //   : eventsCtx?.eventState?.name === '';

  const loading = eventsCtx?.eventState?.name === '';

  // console.log(admin ? '/events-admin' : '/events');

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await authAxios.get(`api/v1/events/${uuid}`);
        eventsCtx.updateAllEventData(response?.data?.data?.attributes);
        eventsCtx.updateFirstLoad(true);
      } catch (error) {
        const { errors } = getErrorResponsePayload(error);
        reportAndToastApiError(error, { description: errors?.[0] });
        navigate('/events', { replace: true });
      }
    };

    getData();
  }, [authAxios]);

  if (!loading) {
    return <>{children}</>;
  }

  return (
    <Spinner
      width="52px"
      height="52px"
      thickness="4px"
      speed="0.65s"
      emptyColor="quinaryBackground"
      m="auto"
    />
  );
};

export default UseEvent;
